import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-heavy-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './heavy-header.component.html',
  styleUrl: './heavy-header.component.scss'
})
export class HeavyHeaderComponent {
  @Input() title: string;
  @Input() description: string = null;
  @Input() lineHeight: number = 1.2
  @Input() mb: string = '24px';
}
